import { Link } from 'react-router-dom';
import { OrgStatusPill } from '../StatusPills';
import { placesInYourLife } from '../../lib/lifeInCare';
import { getOrgTypeLabel } from '../../lib/utils';

/**
 * "The places in your life" — the person's organisations grouped by the
 * part of life they were (who was responsible, school, health, others),
 * each in time order with years and ages, its status, and the "New" dot
 * when something finished there since they last looked.
 */
export const PlacesInYourLife = ({ organisations, user }) => {
  const groups = placesInYourLife(organisations, user?.date_of_birth || null);
  return (
    <section aria-labelledby="places-heading" className="space-y-3" data-testid="organisations-section">
      <div className="flex items-baseline justify-between gap-4">
        <h2 id="places-heading" className="font-heading text-[24px] font-semibold tracking-[-0.02em] text-ink">The places in your life</h2>
        {organisations.length > 0 && (
          <Link to="/organisations" className="text-[15px] font-semibold text-brand hover:text-brand-ink">See all {organisations.length}</Link>
        )}
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-6">
        {groups.map((g) => (
          <div key={g.id} data-testid={`places-${g.id}`}>
            <p className="pd-eyebrow mb-1">{g.title}</p>
            <ul>
              {g.orgs.map(({ org, when }) => (
                <li key={org.id} className="border-b border-rule last:border-b-0">
                  <Link to={`/organisations/${org.id}`} className="flex items-center gap-3 py-3 group" data-testid={`dashboard-org-${org.id}`}>
                    <span className="flex-1 min-w-0">
                      <span className="flex items-center gap-2">
                        <span className="font-semibold text-ink group-hover:text-brand truncate">{org.name}</span>
                        {org.has_news && <span className="w-[8px] h-[8px] rounded-full bg-brand shrink-0" role="img" aria-label="Something new" />}
                      </span>
                      <span className="block text-sm text-ink-55">{[g.id === 'other' || g.id === 'health' ? getOrgTypeLabel(org.type) : null, when].filter(Boolean).join(' · ') || getOrgTypeLabel(org.type)}</span>
                    </span>
                    {org.org_status && (
                      <span className="shrink-0">
                        <OrgStatusPill status={org.org_status} reason={org.org_status_reason} daysRemaining={org.days_remaining} size="sm" />
                      </span>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlacesInYourLife;
